<template>
    <div class="page my">
        <my-skeleton v-if="loading" style="margin-bottom: 100vh"></my-skeleton>

        <div class="my-header">
            <div class="my-header-left">
                <img class="my-header-left-avatar" :src="user.avatar == ''? '/static/bytx/web_broadcast_head.svg' : user.avatar" alt="" />
                <div style="display: inline-block;float: left">
                    <div class="my-header-title">{{ user.name === '' ? user.nick_name : user.name }}</div>
                </div>
                <img v-if="user.is_complete" class="my-header-left-vip" src="/static/img/auth.svg" alt="" />
                <img v-else src="/static/img/unauth.svg" class="my-header-left-vip off" alt="" />
            </div>
            <div class="my-header-right" @click="add_info()" v-if="user.is_complete == 1">
                <img src="/static/bytx/mycenter_health_rule_3_icon.svg" style="width: 16px" alt="" />修改
            </div>
            <div class="my-header-right" @click="goLogin" v-else>
                <img src="/static/bytx/mycenter_health_rule_2_icon.svg" style="width: 16px" alt="" />去登录
            </div>
            <div class="clear"></div>
        </div>

        <div class="control">
            <van-cell
                title-class="control-title"
                title="我的足迹"
                url="/vant/mobile.html"
                icon="/static/bytx/mycenter_list_1_icon.svg"
                icon-size="20px"
                :to="'/my-history'"
            />
            <van-cell
                title-class="control-title"
                title="我的收藏"
                icon="/static/bytx/mycenter_list_2_icon.svg"
                icon-size="20px"
                :to="'/my-favorite'"
            />
            <van-cell
                title-class="control-title"
                title="我的预约/申请"
                url="/vant/mobile.html"
                icon="/static/bytx/mycenter_list_3_icon.svg"
                icon-size="20px"
                :to="'/my-list-order'"
            />
            <van-cell
                title-class="control-title"
                title="联系客服"
                icon="/static/bytx/mycenter_list_4_icon.svg"
                icon-size="20px"
                @click="goWechat()"
            />
            <van-cell
                title-class="control-title"
                title="设置"
                url="/vant/mobile.html"
                icon="/static/bytx/mycenter_list_5_icon.svg"
                icon-size="20px"
                :to="'/my-setting'"
            />
<!--            <van-cell-->
<!--                title-class="control-title"-->
<!--                title="登录"-->
<!--                url="/vant/mobile.html"-->
<!--                icon="/static/bytx/mycenter_list_5_icon.svg"-->
<!--                icon-size="20px"-->
<!--                @click="checkWechat()"-->
<!--            />-->
        </div>

        <van-tabbar
            class="home-footer"
            :fixed="true"
            :safe-area-inset-bottom="true"
            v-model="active"
            active-color="#0FB7AD"
        >
            <van-tabbar-item icon="/static/bytx/home/tab_1_icon.svg" @click="$toHomePage">首页</van-tabbar-item>
            <van-tabbar-item icon="/static/bytx/home/tab_2_icon.svg" :to="'live-list'">看直播</van-tabbar-item>
            <van-tabbar-item icon="/static/bytx/home/tab_3_icon.svg" :to="'comrade-list'">交流社区</van-tabbar-item>
            <van-tabbar-item icon="/static/bytx/home/tab_4_selected_icon.svg" :to="'my'">我的</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
import Interface from '@/util/interface'
import mySkeleton from '@/skeleton/mySkeleton'
import {LocationHref} from '@/util/common'

export default {
    name: 'my',
    components: {
        'my-skeleton': mySkeleton
    },
    data() {
        return {
            value: '',
            active: 3,
            banners: [],
            recommend: [],
            articles: [],
            user: {},
            loading: true
        }
    },
    methods: {
        fetch(scene) {
            if (scene === 'userinfo') {
                Interface.getData('get', Interface.user.user_info).then(res => {
                    if (res.code === 0 || res.code === 1) {
                        this.user = res.data
                        setTimeout(() => {
                            this.loading = false
                        }, 500)
                    } else {
                        this.error = true;
                        LocationHref(Interface.api + "/wechat-phase/wxOauth?redirect_url=" + Interface.host + "&path=" + this.$route.path)
                    }
                })
            }
        },
        goLogin() {
            sessionStorage.setItem('back-url', this.$route.path)
            sessionStorage.setItem(
                'apply',
                JSON.stringify({
                    apply: 'update',
                    apply_id: 0
                })
            )
            this.$router.push({ name: 'login' })
        },
        add_info() {
            sessionStorage.setItem('back-url', this.$route.path)
            sessionStorage.setItem(
                'apply',
                JSON.stringify({
                    apply: 'update',
                    apply_id: 0
                })
            )
            this.$router.push({ name: 'add-info', query: { update: 1 } })
        },
        goWechat() {
            LocationHref('https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8')
        },
        checkWechat() {
            location.href = 'https://open.work.weixin.qq.com/3rdapp/install?suite_id=wwb557ef60c80537d0&pre_auth_code=E3bmlp-ie--JO0T3nRhogpd-083y2AGonY9dw5vSO5s8SoQHMUP0iz75v_Czg6WR&redirect_uri='+encodeURI(window.location.href)+'&state=STATE'
        }
    },
    created() {
        this.fetch('userinfo')
        sessionStorage.removeItem('apply')
        Interface.getShareInfo(this, '', '', '')
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/my/index.vue